import { useEffect, useState } from "react";
import throttle from "lodash/throttle";
import { domElementIds } from "@shared/constants/common";
import { waitForElementToLoad } from "@shared/services/loaders/element-loader";
import { checkForReactNativeAttribute } from "@shared/hooks/platform/react-native";

const { navbarBannerId } = domElementIds;

/**
 * Calculates the offset needed for the header tab component on all detail pages
 * Used on the EventDetailsHeader and MembershipDetailsHeader
 */
const useDetailPageTabHeight = (basketHasItems: boolean): string => {
  const [tabHeight, setTabHeight] = useState("0px");
  const isReactNativeWebview = checkForReactNativeAttribute();

  // get the height of any navbar banners that are currently displayed
  // set the top of the tab component based on the retrieved height
  const handleTabHeight = () => {
    const bannerHeight =
      document?.getElementById(navbarBannerId)?.scrollHeight ?? 0;
    setTabHeight(`${bannerHeight}px`);
  };

  // handle tab height based on initial load and resize events
  useEffect(() => {
    // Mobile app does not show the navbar banner
    if (isReactNativeWebview) {
      return;
    }

    waitForElementToLoad(`#${navbarBannerId}`).then(() => {
      handleTabHeight();
      let handleResizeDelay;

      // add delay to function call so that we get the tab height display at the end of the resize event
      window.addEventListener("resize", () => {
        clearTimeout(handleResizeDelay);
        handleResizeDelay = setTimeout(
          throttle(() => {
            handleTabHeight();
          }, 250),
          100
        );
      });
    });
    // this useEffect should run once on page load
    // and again when the basket's item_groups change
  }, [basketHasItems, isReactNativeWebview]);

  return tabHeight;
};

export default useDetailPageTabHeight;
